// extracted by mini-css-extract-plugin
export default {"wrapper":"download-button-module--wrapper--7fe37","title":"download-button-module--title--191d4"};